import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  dragIsIn = false;
  fileTypes = 'image/*,application/pdf';
  private fileTypeNames = 'a PDF or image';
  @Input() files: File[];
  @Input() pdfOnly: boolean; // Pick at most one of these
  @Input() imageOnly: boolean; // Pick at most one of these
  @Input() multiple = true;
  errorMessage: string;
  jotFormName: string;
  jotFormLink: string;
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.pdfOnly) {
      this.fileTypes = 'application/pdf';
      this.fileTypeNames = 'a PDF';
    } else if (this.imageOnly) {
      this.fileTypes = 'image/*';
      this.fileTypeNames = 'an image';
    }
  }

  get fileTypesInstructionFragment(): string {
    if (this.pdfOnly) {
      return 'PDF';
    } else if (this.imageOnly) {
      return 'Image';
    } else {
      return 'Image or PDF';
    }
  }

  fileOver(event: MouseEvent) {
    this.dragIsIn = true;
  }

  fileLeave(event: MouseEvent) {
    this.dragIsIn = false;
  }

  async dropped(files: NgxFileDropEntry[]) {
    this.errorMessage = '';
    this.dragIsIn = false;
    let found = false;
    if (files.length > 1 && !this.multiple) {
      this.errorMessage = 'You can only upload a single file here';
    } else {
      for (const droppedFile of files) {
        if (droppedFile.fileEntry.isFile) {
          // e.g. not a directory, just a sanity check
          // Need to await the file so we know whether any valid ones were found for the close check after the loop
          const file = await this.extractFile(
            droppedFile.fileEntry as FileSystemFileEntry
          );
          if (
            (!this.imageOnly && file.type === 'application/pdf') ||
            (!this.pdfOnly && /^image\//.test(file.type))
          ) {
            this.files.push(file);
            found = true;
          } else this.errorMessage = 'Not ' + this.fileTypeNames + ' file';
        }
      }
    }
    if (found) this.modal.close();
  }

  extractFile(source: FileSystemFileEntry): Promise<File> {
    return new Promise(resolve => source.file(file => resolve(file)));
  }

  submitJotForm() {
    console.log(
      'jot form name: ' +
        this.jotFormName +
        ' jot form link: ' +
        this.jotFormLink
    );
    const formId = this.jotFormLink.split('/').pop() || '';
    this.files.push(
      new File([this.jotFormLink], 'jot|' + formId + '|' + this.jotFormName, {
        type: 'image/png'
      })
    );
    this.modal.close();
  }
}
